import * as React from "react";
import styled from "styled-components";

import i18n from "../../lib/i18n";
import { CompanyValue } from "../entities";
import { EntityValidationResultMap } from "../../lib/entities/validation";
import Translate from "../../common/components/Translate";
import Icon from "../../common/components/Icon";
import { Hint } from "../../common/components/popover";
import { NavigatableSection, SectionInner, SectionTitle } from "./Section";
import CompanyValueGrid from "../../company_values/components/CompanyValueGrid";
import StartActionCard from "./StartActionCard";

interface Props {
  companyValues: CompanyValue[];
  locale: string;
  editable: boolean;
  validationErrors: EntityValidationResultMap<CompanyValue>;
  onStartSelecting?(): void;
  onChange?(companyValues: CompanyValue[]): void;
}

const VALUES_LP_AVAILABLE_LOCALES = ["ja"];

const ValuesLPAnnouncement: React.SFC<{}> = () => {
  return (
    <div style={{ color: "rgba(0, 0, 0, 0.8)", fontSize: "13px", marginBottom: "30px" }}>
      【お知らせ】4月9日 (月) に
      <a href="/values" target="_blank">
        「価値観」で会社を探せる特設ページ
      </a>
      を公開いたしました。 こちらから価値観をご入力いただくと、特設ページに会社が掲載されますので、ぜひご入力ください。
    </div>
  );
};

const ValuesLPStartCard: React.SFC<{ onClick?(): void }> = ({ onClick }) => {
  return (
    <StartCard>
      <Image src="https://dubpy8abnqmkw.cloudfront.net/images/company/company_megaphone.png" />
      <Messages>
        <Message>
          <Translate id="company.home.start_values_card.message" />
        </Message>
        <SubMessage>
          <Translate id="company.home.start_values_card.sub_message" />
        </SubMessage>
        <ValuesLPAnnouncement />
        <Button onClick={onClick}>
          <Translate id="company.home.start_values_card.button_text" />
        </Button>
      </Messages>
    </StartCard>
  );
};

const ValuesSection: React.SFC<Props> = props => {
  const { companyValues, locale, editable, validationErrors, onStartSelecting, onChange } = props;
  const hasContent = companyValues.length > 0;

  if (!editable && !hasContent) {
    return null;
  }
  return (
    <NavigatableSection id="values" displayName={i18n.translate("company.home.sections.values", { locale })}>
      <SectionInner>
        <SectionTitle>
          <Translate id="company.home.sections.values" />
          <StyledHint text={i18n.translate("company.values.hint_for_user", { locale })} />
          {editable && hasContent && <EditIcon name="wt-icon-pencil" onClick={onStartSelecting} />}
        </SectionTitle>
        {editable &&
          !hasContent &&
          (VALUES_LP_AVAILABLE_LOCALES.includes(locale) ? (
            <ValuesLPStartCard onClick={onStartSelecting} />
          ) : (
            <StartActionCard
              message={i18n.translate("company.home.start_values_card.message")}
              subMessage={i18n.translate("company.home.start_values_card.sub_message")}
              buttonText={i18n.translate("company.home.start_values_card.button_text")}
              onClick={onStartSelecting}
            />
          ))}
        {hasContent && (
          <CompanyValueGrid
            companyValues={companyValues}
            editable={editable}
            validationErrors={validationErrors}
            onChange={onChange}
          />
        )}
      </SectionInner>
    </NavigatableSection>
  );
};

const EditIcon = styled(Icon)`
  margin-left: auto;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.6;
  }
`;

const StyledHint = styled(Hint)`
  font-size: 14px;
  margin-left: 6px;
  line-height: 23px;
  vertical-align: center;
  opacity: 0.8;
`;

const StartCard = styled.div`
  width: 910px;
  height: 400px;
  border-radius: 12px;
  background-color: #fafafa;
  display: flex;
  padding: 0 30px 0 10px;
  box-sizing: border-box;
  margin: auto;
`;

const Image = styled.img``;

const Messages = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 16px;
`;

const Message = styled.h4`
  font-size: 22px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
  padding-bottom: 8px;
`;

const SubMessage = styled.p`
  font-size: 13px;
  font-weight: 400;
  line-height: 1.38;
  color: rgba(0, 0, 0, 0.56);
  width: 316px;
  padding-bottom: 36px;
`;

const Button = styled.button`
  display: inline-block;
  width: 138px;
  height: 33px;
  border-radius: 60px;
  padding: 0 20px;
  margin-left: 4px;
  font-weight: 600;
  font-size: 13px;
  line-height: 33px;
  text-align: center;
  background-color: #21bddb; /* blue400 */
  color: white;
  border: none;
  outline: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: #00aed1; /* blue500 */
  }
`;

export default ValuesSection;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/ValuesSection.tsx